import { 
    Briefcase, 
    Network, 
    TrendingUp, 
    UserCheck, 
    Target, 
    Bug, 
    BarChart, 
    Brain, 
    Rocket, 
    Settings, 
    Layers, 
    Coffee, 
    TestTube2, 
    Monitor, 
    Database,
    Code,
    Smartphone,
    Cloud,
    Users,
    Palette,
    Server,
    Globe,
    Bot,
    Zap,
    Eye,
    MessageSquare,
    BarChart3,
    Cpu
} from 'lucide-react';
import { aimlCourses } from './aiml';

export const selfPacedCourses = [
    {
        id: "java-for-beginners",
        slug: "java-for-beginners",
        title: "Java for Beginners",
        externalUrl: "https://gontq.courses.store/501137?utm_source=other&utm_medium=tutor-course-referral&utm_campaign=course-overview-webapp",
        fallbackUrl: "https://gontq.courses.store/",
        category: "self-paced",
        description: "Ready to start coding but dont know where to begin Java for Beginners is the ultimate launchpad for anyone looking to break into tech with one of the most powerful and versatile programming languages in the world.This course is more than just tutorials — its a hands-on, project-based learning experience designed to take you from zero to confident coder. Whether you're aiming to build apps, ace a coding interview, or simply learn a valuable new skill.",
        image: "/path/to/java-image.jpg",
        price: 3445,
        originalPrice: 6500,
        level: "Beginner",
        tools: ["Java Development Kit (JDK)", "VS Code", "Notepad", "CMD"],
        duration: "2 Months",
        lectures: "35+",
        mode: "Self Paced",
        language: "Hindi/English",
        certificate: "Industry Recognized Certificate",
        tests: "10+",
        assignments: "10+",
        banner: {
            title: "Java for Beginners",
            subtitle: "Complete Core Concepts of Java Language",
            background: "bg-gradient-to-r from-blue-600 to-blue-800",
            Icon: null
        },
        // overview: "Discover the basics of Java programming from scratch as we cover essential topics such as variables, control flow, object-oriented programming, and more. Our engaging tutorials are tailored to help you grasp Java concepts easily, whether you're a newcomer to programming or looking to expand your skill set.",
        highlights: [
            "Most Premium Course",
            "No Experience Needed",
            "Problem-Solving Techniques",
            "Assessment via Online Test",
            "Practical Approach",
            "Access to our Placement cell"
        ],
        selfPacedFeatures: [
            "Learn at your own pace",
            "24/7 access to learning materials",
            "Flexible learning schedule",
            "Assignments & Online Test",
            "Downloadable resources"
        ],
        learningFormat: {
            duration: "Self-paced",
            mode: "Online",
            effort: "4-6 hours/week recommended",
            includes: [
                "HD Quality Videos",
                "Hands-on Projects",
                "Assignments & Quizzes",
                "Doubt Resolution",
                "Certificate of Completion"
            ]
        },
        curriculum: [
            {
                title: "Introduction to Java",
                topics: [
                    "• Overview of Java and its Features",
                    "• Java Editions, Versions, and Compilation Process",
                    "• JDK, JRE, JVM Overview",
                    "• Applications of Java"
                ]
            },
            {
                title: "Basic Syntax and Structure",
                topics: [
                    "• First Java Program",
                    "• Print Methods and Variables",
                    "• Data Types (Primitive and Non-Primitive)",
                    "• ASCII and Unicode"
                ]
            },
            {
                title: "Control Flow and Operators",
                topics: [
                    "• Conditional Statements (if, else, switch)",
                    "• Looping Constructs (for, while, do-while, for-each)",
                    "• Operators (Arithmetic, Relational, Bitwise, Assignment)",
                    "• Operator Precedence and Type Casting"
                ]
            },
            {
                title: "Object-Oriented Programming (OOP) Basics",
                topics: [
                    "• Introduction to OOP Concepts (Classes, Objects, Inheritance, Polymorphism)",
                    "• Access Modifiers and the this Keyword"
                ]
            },
            {
                title: "Constructors and Methods",
                topics: [
                    "• Types of Constructors (Default, Parameterized, Copy)",
                    "• Method Overloading and Constructor Overloading",
                    "• Static Methods and the Object Class"
                ]
            },
            {
                title: "Arrays and Strings",
                topics: [
                    "• Introduction to Arrays (Single and Two-Dimensional)",
                    "• Operations on Arrays",
                    "• String Basics and String Methods"
                ]
            },
            {
                title: "Exception Handling",
                topics: [
                    "• Introduction to Exception Handling in Java",
                    "• Try-Catch Blocks and Finally Statement"
                ]
            },
            {
                title: "Wrapper Classes and Type Conversion",
                topics: [
                    "• Overview of Wrapper Classes",
                    "• Conversion Between Primitive Types and Wrapper Classes"
        ]
    },
    {
                title: "Advanced OOP Concepts",
                topics: [
                    "• Abstract Classes and Interfaces",
                    "• Practical Examples of Inheritance",
                    "• Method Overriding"
                ]
            },
            {
                title: "Java Special Features",
                topics: [
                    "• Introduction to Varargs",
                    "• Special Keywords in Java"
                ]
            },
            {
                title: "File Handling in Java",
                topics: [
                    "• File I/O Basics",
                    "• Reading and Writing Files"
                ]
            },
            {
                title: "Real-world Projects and Applications",
                topics: [
                    "• Practical Coding Exercises and Assignments",
                    "• Final Project to Demonstrate Your Skills"
                ]
            }
        ],
        skills: [
            "Java Programming",
            "Object-Oriented Programming Concepts"
        ]
    },
    {
        id: "java-for-developers",
        slug: "java-for-developers",
        title: "Java for Developers",
        category: "self-paced",
        description: "Java isn't just a language — it's a gateway to building scalable, secure, and high-performance web applications. This Core Java + Advance Java course by OSOPCoding is designed for aspiring developers who want to master Java fundamentals and transition into full-stack or backend web development using powerful, real-world technologies.",
        image: "/path/to/java-dev-image.jpg",
        price: 6625,
        originalPrice: 12500,
        externalUrl: "https://gontq.courses.store/501145?utm_source%3Dother%26utm_medium%3Dtutor-course-referral%26utm_campaign%3Dcourse-overview-webapp",
        level: "Intermediate to Advanced",
        tools: ["Java Development Kit (JDK)", "VS Code", "Eclipse", "IntelliJ IDEA", "Apache Tomcat"],
        duration: "3 Months",
        lectures: "55+",
        mode: "Self Paced",
        language: "Hindi/English",
        certificate: "Industry Recognized Certificate",
        tests: "10+",
        assignments: "10+",
        banner: {
            title: "Java for Developers",
            subtitle: "Master Advanced Java Programming",
            background: "bg-gradient-to-r from-blue-600 to-blue-800",
            Icon: Coffee
        },
        // overview: "Whether you're looking to enhance your existing skills or start a new journey in software development, this comprehensive course will guide you through the essentials of Java and beyond.",
        prerequisites: "Basic knowledge of programming concepts is required before joining this course to ensure a smooth learning experience.",
        highlights: [
            "Most Premium Course",
            "No Experience Needed",
            "Problem-Solving Techniques",
            "Assessment via Online Test",
            "Practical Approach",
            "Access to our Placement cell"
        ],
        whyOsop: [
            "India's most premium coding class",
            "26+ Years of Technology Training",
            "Zero Error Programming",
            "Strong Conceptual & Practical Knowledge"
        ],
        selfPacedFeatures: [
            "Learn at your own pace",
            "24/7 access to learning materials",
            "Flexible learning schedule",
            "Assignments & Online Test",
            "Downloadable resources"
        ],
        learningFormat: {
            duration: "Self-paced",
            mode: "Online",
            effort: "8-10 hours/week recommended",
            includes: [
                "HD Quality Videos",
                "Hands-on Projects",
                "Assignments & Quizzes",
                "Doubt Resolution",
                "Certificate of Completion"
            ]
        },
        curriculum: [
            {
                title: "Java Basics",
                topics: [
                    "• What is Java?",
                    "• Why Java?",
                    "• History of Java",
                    "• Applications of Java",
                    "• Features of Java",
                    "• Advantages of Java",
                    "• Versions of Java",
                    "• Installation of Java",
                    "• Setting up the Java Environment"
                ]
            },
            {
                title: "Java Fundamentals",
                topics: [
                    "• Java Data Types",
                    "• Variables and Constants",
                    "• Comments in Java",
                    "• Output with System.out.print()",
                    "• Input Handling",
                    "• Type Conversion"
                ]
            },
            {
                title: "Operators in Java",
                topics: [
                    "• Arithmetic Operators",
                    "• Comparison Operators",
                    "• Logical Operators",
                    "• Assignment Operators",
                    "• Bitwise Operators",
                    "• Ternary Operator"
                ]
            },
            {
                title: "Control Statements",
                topics: [
                    "• Conditional Statements (if, switch)",
                    "• Looping Statements (for, while, do-while)",
                    "• Break and Continue Statements"
                ]
            },
            {
                title: "Java Arrays",
                topics: [
                    "• Introduction to Arrays",
                    "• Creating Arrays",
                    "• Accessing Array Elements",
                    "• Multi-Dimensional Arrays",
                    "• Array Methods"
                ]
            },
            {
                title: "Methods in Java",
                topics: [
                    "• Defining Methods",
                    "• Calling Methods",
                    "• Method Overloading",
                    "• Variable Length Arguments",
                    "• Return Types and Parameters"
                ]
            },
            {
                title: "Object-Oriented Programming (OOP) Concepts",
                topics: [
                    "• Introduction to OOP",
                    "• Classes and Objects",
                    "• Encapsulation",
                    "• Inheritance",
                    "• Polymorphism",
                    "• Abstraction"
                ]
            },
            {
                title: "Exception Handling",
                topics: [
                    "• Understanding Exceptions",
                    "• Types of Exceptions",
                    "• Try, Catch, Finally Blocks",
                    "• Throwing Exceptions",
                    "• Custom Exception Classes"
        ]
    },
    {
                title: "Java Collections Framework",
                topics: [
                    "• Introduction to Collections",
                    "• List, Set, Map Interfaces",
                    "• ArrayList, HashSet, HashMap",
                    "• Iterators and Enhanced for Loop"
                ]
            },
            {
                title: "Java Streams API",
                topics: [
                    "• Introduction to Streams",
                    "• Stream Operations (filter, map, reduce)",
                    "• Collecting Results"
                ]
            },
            {
                title: "Java Input/Output (I/O)",
                topics: [
                    "• File Handling",
                    "• Reading and Writing Files",
                    "• Serialization and Deserialization"
                ]
            },
            {
                title: "Web Development with Java",
                topics: [
                    "• Introduction to Servlets",
                    "• Lifecycle of a Servlet",
                    "• Handling HTTP Requests and Responses",
                    "• Session Management",
                    "• Introduction to JSP",
                    "• JSP Lifecycle",
                    "• JSP Tags and Expressions",
                    "• Integrating JSP with Servlets"
                ]
            },
            {
                title: "Java Database Connectivity (JDBC)",
                topics: [
                    "• Introduction to JDBC",
                    "• Establishing Database Connections",
                    "• Executing SQL Queries",
                    "• Handling Transactions and Exceptions"
                ]
            }
        ],
        skills: [
            "Java Programming",
            "Object-Oriented Programming",
            "Web Development with Java",
            "Database Programming",
            "Enterprise Application Development"
        ]
    },
    {
        id: "dsa-cpp",
        slug: "dsa-cpp",
        title: "Data Structures and Algorithms (DSA) using C++",
        externalUrl: "https://gontq.courses.store/501143?utm_source=other&utm_medium=tutor-course-referral&utm_campaign=course-overview-webapp",
        fallbackUrl: "https://gontq.courses.store/",
        category: "self-paced",
        description: "Want to crack coding interviews, solve real-world problems, or simply become a smarter programmer? Welcome to DSA with C++ by OSOPCoding — your beginner-friendly gateway to mastering one of the most critical pillars of computer science. Data Structures and Algorithms (DSA) are the backbone of efficient programming. This course is designed to help absolute beginners understand, visualize, and implement DSA concepts step-by-step using C++, one of the most powerful languages in the industry.",
        image: "/path/to/dsa-cpp-image.jpg",
        price: 2650,
        originalPrice: 5000,
        level: "Beginner to Intermediate",
        tools: ["C++ Compiler", "Visual Studio", "Code::Blocks", "Dev-C++"],
        duration: "2 Months",
        lectures: "35+",
        mode: "Self Paced",
        language: "Hindi/English",
        certificate: "Industry Recognized Certificate",
        tests: "10+",
        assignments: "10+",
        banner: {
            title: "DSA using C++",
            subtitle: "Master Data Structures and Algorithms",
            background: "bg-gradient-to-r from-purple-600 to-purple-800",
            Icon: Code
        },
        // overview: "By learning DSA, students will enhance their programming skills, improve code performance, and prepare for technical interviews. This course covers a wide array of topics from the basics to advanced data structures and algorithms.",
        prerequisites: "Basic knowledge of C++ programming is required before joining this course to ensure a smooth learning experience.",
        highlights: [
             "Most Premium Course",
            "No Experience Needed",
            "Problem-Solving Techniques",
            "Assessment via Online Test",
            "Practical Approach",
            "Access to our Placement cell"
        ],
        whyOsop: [
            "India's most premium coding class",
            "26+ Years of Technology Training",
            "Zero Error Programming",
            "Strong Conceptual & Practical Knowledge"
        ],
        selfPacedFeatures: [
           "Learn at your own pace",
            "24/7 access to learning materials",
            "Flexible learning schedule",
            "Assignments & Online Test",
            "Downloadable resources"
        ],
        learningFormat: {
            duration: "Self-paced",
            mode: "Online",
            effort: "10-12 hours/week recommended",
            includes: [
                "HD Quality Videos",
                "Hands-on Projects",
                "Assignments & Quizzes",
                "Doubt Resolution",
                "Certificate of Completion"
            ]
        },
        curriculum: [
            {
                title: "Introduction to DSA",
                topics: [
                    "• Overview and Types of Data Structures"
                ]
            },
            {
                title: "Prerequisites for DSA",
                topics: [
                    "• Functions",
                    "• Arrays",
                    "• Classes & Objects",
                    "• Pointers",
                    "• Object Patterning"
                ]
            },
            {
                title: "Address Calculation",
                topics: [
                    "• Address Calculation of 1-D, 2-D, and 3-D Arrays"
                ]
            },
            {
                title: "Time & Space Complexity",
                topics: [
                    "• Best Case (Ω)",
                    "• Average Case (Θ)",
                    "• Worst Case (O)"
                ]
            },
            {
                title: "Stacks",
                topics: [
                    "• Definition, Operations, Applications",
                    "• Static (Array) and Dynamic (Linked List) Implementation"
                ]
            },
            {
                title: "Queues",
                topics: [
                    "• Definition, Operations, Applications",
                    "• Static (Array) and Dynamic (Linked List) Implementation"
                ]
            },
            {
                title: "Linked Lists",
                topics: [
                    "• Singly, Doubly, and Circular Linked Lists",
                    "• Definition and Applications"
                ]
            },
            {
                title: "Recursion & Backtracking",
                topics: [
                    "• Concept and Basic Problems with Implementation"
                ]
            },
            {
                title: "Sorting",
                topics: [
                    "• Let's Play with Code",
                    "• Incremental Approach:",
                    "  - Bubble Sort",
                    "  - Selection Sort",
                    "  - Insertion Sort",
                    "  - Radix Sort",
                    "• Divide & Conquer Approach:",
                    "  - Merge Sort",
                    "  - Quick Sort",
                    "  - Heap Sort"
                ]
            },
            {
                title: "Searching",
                topics: [
                    "• Linear Search",
                    "• Binary Search"
                ]
            },
            {
                title: "Dynamic Programming",
                topics: [
                    "• Optimization on Recursion",
                    "• Tabulation and Memorization",
                    "• Solutions to Common Problems"
                ]
            },
            {
                title: "Trees",
                topics: [
                    "• Binary Trees and Binary Search Trees",
                    "• Definition, Creation, Implementation, and Traversals",
                    "• AVL Trees"
                ]
            },
            {
                title: "Graphs",
                topics: [
                    "• Definition, Operations, Applications",
                    "• Graph Algorithms (Dijkstra's, Bellman-Ford)"
                ]
            },
            {
                title: "Hashing Techniques",
                topics: [
                    "• Concept and Collision Handling Techniques",
                    "• How to Select Hashing Functions"
        ]
    },
    {
                title: "Greedy Algorithms",
                topics: [
                    "• Need & Concepts",
                    "• Solutions to Common Problems"
                ]
            }
        ],
        skills: [
            "C++ Programming",
            "Data Structures",
            "Algorithms",
            "Problem-Solving",
            "Time Complexity Analysis",
            "Space Complexity Analysis"
        ]
    },
    {
        id: "sql-beginners",
        slug: "sql-beginners",
        title: "SQL for Beginners",
        externalUrl: "https://gontq.courses.store/501140?utm_source%3Dother%26utm_medium%3Dtutor-course-referral%26utm_campaign%3Dcourse-overview-webapp",
        fallbackUrl: "https://gontq.courses.store/",
        category: "self-paced",
        description: "Databases are everywhere — behind every app, website, and digital service you use. SQL (Structured Query Language) is the key to unlocking, managing, and understanding data efficiently. This beginner-friendly course by OSOPCoding is built from the ground up to help you learn SQL the right way — with a focus on clarity, logic, and zero-error programming. No coding experience? No problem. We'll guide you step-by-step through the essentials so you can query, analyze, and manage data with confidence.",
        image: "/path/to/sql-beginners-image.jpg",
        price: 1590,
        originalPrice: 3000,
        level: "Beginner",
        tools: ["MySQL Workbench", "Command Line Interface (CLI)", "phpMyAdmin", "MySQL Server"],
        duration: "1 Month",
        lectures: "35+",
        mode: "Self Paced",
        language: "Hindi/English",
        certificate: "Industry Recognized Certificate",
        tests: "10+",
        assignments: "10+",
        banner: {
            title: "SQL for Beginners",
            subtitle: "Master Database Management",
            background: "bg-gradient-to-r from-green-600 to-green-800",
            Icon: Database
        },
        // overview: "This course covers fundamental concepts to advanced SQL functionalities, making it suitable for learners with no prior database experience.",
        prerequisites: "No prior database experience required. Basic computer literacy is sufficient to start this course.",
        highlights: [
            "Most Premium Course",
            "No Experience Needed",
            "Problem-Solving Techniques",
            "Assessment via Online Test",
            "Practical Approach",
            "Access to our Placement cell"
        ],
        whyOsop: [
            "India's Most Premium Coding Class",
            "26+ Years of Technology Training",
            "Zero Error Programming",
            "Strong Conceptual & Practical Knowledge"
        ],
        selfPacedFeatures: [
          "Learn at your own pace",
            "24/7 access to learning materials",
            "Flexible learning schedule",
            "Assignments & Online Test",
            "Downloadable resources"
        ],
        learningFormat: {
            duration: "Self-paced",
            mode: "Online",
            effort: "6-8 hours/week recommended",
            includes: [
                "HD Quality Videos",
                "Hands-on Projects",
                "Assignments & Quizzes",
                "Doubt Resolution",
                "Certificate of Completion"
            ]
        },
        curriculum: [
            {
                title: "Introduction to Database",
                topics: [
                    "• Definition of Database",
                    "• Drawbacks of File System"
                ]
            },
            {
                title: "Database Management System (DBMS)",
                topics: [
                    "• What is DBMS?",
                    "• Types of DBMS"
                ]
            },
            {
                title: "MySQL Overview",
                topics: [
                    "• Introduction to MySQL",
                    "• History of MySQL"
                ]
            },
            {
                title: "Introduction to SQL",
                topics: [
                    "• What is SQL?",
                    "• What Can SQL Do?",
                    "• SQL Commands"
                ]
            },
            {
                title: "SQL Data Types",
                topics: [
                    "• Introduction to SQL Data Types"
                ]
            },
            {
                title: "SQL Commands",
                topics: [
                    "• SQL Create Statement",
                    "• Insert Statement"
                ]
            },
            {
                title: "Data Retrieval",
                topics: [
                    "• Select Command",
                    "• Where Clause",
                    "• SQL Syntax Overview"
                ]
            },
            {
                title: "SQL Operators",
                topics: [
                    "• Basic SQL Operators",
                    "• Logical Operators",
                    "• ORDER BY Clause",
                    "• BETWEEN Clause",
                    "• LIKE Operator and Wildcards"
                ]
            },
            {
                title: "Data Manipulation",
                topics: [
                    "• Delete Command",
                    "• Update Command"
                ]
            },
            {
                title: "Constraints in SQL",
                topics: [
                    "• Primary Key, Unique Key, NOT NULL",
                    "• Foreign Key",
                    "• ALTER TABLE Operations"
                ]
            },
            {
                title: "Date and Time",
                topics: [
                    "• Data/Time Data Types",
                    "• Date and Time Functions"
                ]
            },
            {
                title: "Regular Expressions",
                topics: [
                    "• Introduction to REGEXP",
                    "• REGEXP Examples"
                ]
            },
            {
                title: "Additional Constraints",
                topics: [
                    "• CHECK Constraint",
                    "• DEFAULT Constraint"
                ]
            },
            {
                title: "Aggregate Functions",
                topics: [
                    "• Using Aggregate Functions: SUM(), MIN(), AVG(), etc."
        ]
    },
    {
                title: "Nested Queries",
                topics: [
                    "• Subquery within Another Query"
                ]
            },
            {
                title: "Joins in SQL",
                topics: [
                    "• Inner Join",
                    "• Left Outer Join",
                    "• Right Outer Join",
                    "• Full Outer Join",
                    "• Self Join"
                ]
            },
            {
                title: "Grouping Data",
                topics: [
                    "• Group By Statement",
                    "• Example Queries of Group Statement",
                    "• HAVING Clause"
                ]
            },
            {
                title: "Indexing",
                topics: [
                    "• Creating and Dropping Index"
                ]
            },
            {
                title: "Views in SQL",
                topics: [
                    "• Creating and Dropping Views"
                ]
            },
            {
                title: "User Privileges",
                topics: [
                    "• GRANT",
                    "• REVOKE"
                ]
            }
        ],
        skills: [
            "SQL Programming",
            "Database Management",
            "Data Retrieval",
            "Data Manipulation",
            "Database Design",
            "Query Optimization"
        ]
    },
    {
        id: "c-cpp-dsa-combo",
        slug: "c-cpp-dsa-combo",
        title: "C/C++/DSA Combo Course",
        externalUrl: "https://gontq.courses.store/711592?utm_source%3Dother%26utm_medium%3Dtutor-course-referral%26utm_campaign%3Dcourse-overview-webapp",
        fallbackUrl: "https://gontq.courses.store/",
        category: "self-paced",
        description: "The C/C++ + DSA Combo Course by OSOPCoding is your complete pathway to master programming fundamentals, problem-solving, and data structures — all with a zero-error programming approach. From writing your first 'Hello World' to solving complex algorithmic challenges, this course is designed to take you from beginner to confident coder — using the powerful combination of C, C++, and Data Structures & Algorithms (DSA).",
        image: "/path/to/c-cpp-dsa-combo-image.jpg",
        price: 5830,
        originalPrice: 11000,
        level: "Beginner to Intermediate",
        tools: ["GCC Compiler", "Visual Studio", "Code::Blocks", "Dev-C++", "GDB Debugger"],
         duration: "4.5 Months",
        lectures: "55+",
        mode: "Self Paced",
        language: "Hindi/English",
        certificate: "Industry Recognized Certificate",
        tests: "10+",
        assignments: "10+",
        banner: {
            title: "C/C++/DSA Combo",
            subtitle: "Complete Programming Foundation",
            background: "bg-gradient-to-r from-orange-600 to-red-600",
            Icon: Code
        },
        // overview: "You'll begin with C programming, where you'll understand how computers work at a low level, including memory management and system-level concepts. Then, you'll dive into C++, exploring the full capabilities of Object-Oriented Programming (OOP), equipping you to write clean, modular, and scalable code. Finally, you'll master Data Structures and Algorithms (DSA) using C++, essential for technical interviews, competitive programming, and high-performance application development.",
        prerequisites: "No prior programming experience required. Basic computer literacy is sufficient to start this comprehensive course.",
        highlights: [
            "Most Premium Course",
            "No Experience Needed",
            "Problem-Solving Techniques",
            "Assessment via Online Test",
            "Practical Approach",
            "Access to our Placement cell"
        ],
        whyOsop: [
            "India's most premium coding class",
            "26+ Years of Technology Training",
            "Zero Error Programming",
            "Strong Conceptual & Practical Knowledge"
        ],
        selfPacedFeatures: [
          "Learn at your own pace",
            "24/7 access to learning materials",
            "Flexible learning schedule",
            "Assignments & Online Test",
            "Downloadable resources"
        ],
        learningFormat: {
            duration: "Self-paced",
            mode: "Online",
            effort: "12-15 hours/week recommended",
            includes: [
                "HD Quality Videos",
                "Hands-on Projects",
                "Assignments & Quizzes",
                "Doubt Resolution",
                "Certificate of Completion"
            ]
        },
        curriculum: [
            {
                title: "Module 1: Core C Programming (Foundation)",
                topics: [
                    "• Introduction to Programming & C Language",
                    "  - History, uses, compiler setup, structure of a C program",
                    "• Variables, Data Types & Operators",
                    "  - Constants, type casting, ASCII, bitwise operators",
                    "• Control Structures",
                    "  - if/else, switch, loops (for, while, do-while), nested loops",
                    "• Functions & Recursion",
                    "  - Function declaration, definition, recursion basics",
                    "• Pointers & Memory",
                    "  - Basics, pointer arithmetic, dynamic memory allocation",
                    "• Arrays & Strings",
                    "  - 1D/2D arrays, string functions, matrix operations",
                    "• User-defined Data Types",
                    "  - Structures, unions, typedef, enums",
                    "• File Handling",
                    "  - File operations, modes, file pointers"
                ]
            },
            {
                title: "Module 2: C++ Programming with OOP Concepts",
                topics: [
                    "• C++ Basics",
                    "  - cout/cin, namespaces, reference variables, std::string class",
                    "• Object-Oriented Programming",
                    "  - Classes & Objects, Encapsulation, Abstraction",
                    "  - Inheritance (Single, Multiple, Multilevel, Hierarchical, Hybrid)",
                    "  - Polymorphism: Compile-Time & Run-Time",
                    "  - Object Passing and Returning",
                    "• Advanced C++ Concepts",
                    "  - this pointer",
                    "  - Scope Resolution Operator",
                    "  - Static Members & Functions",
                    "  - Constructors & Destructors (Types, Overloading)",
                    "  - Inline Functions",
                    "  - Default Arguments",
                    "• Operator Overloading",
                    "  - Arithmetic & Relational Operator Overloading",
                    "  - Overloading << and >> (Insertion & Extraction)",
                    "• Friend Functions & Classes",
                    "  - Use cases and syntax",
                    "• Memory & Exception Handling",
                    "  - Dynamic Object Creation",
                    "  - Exception Handling (try, catch, throw)",
                    "• Templates & Generic Programming",
                    "  - Function Templates",
                    "  - Class Templates",
                    "• File Handling in C++",
                    "  - File Streams and Modes",
                    "  - Text and Binary File Operations",
                    "  - I/O Formatting & Manipulators",
                    "  - User-defined Manipulators",
                    "• OOP Relationships",
                    "  - IS-A vs HAS-A",
                    "  - Generalization and Specialization",
                    "  - Abstract Classes & Virtual Functions"
                ]
            },
            {
                title: "Module 3: Introduction to DSA",
                 topics: [
                    "• Overview and Types of Data Structures"
                ]
            },
            {
                title: "Prerequisites for DSA",
                topics: [
                    "• Functions",
                    "• Arrays",
                    "• Classes & Objects",
                    "• Pointers",
                    "• Object Patterning"
                ]
            },
            {
                title: "Address Calculation",
                topics: [
                    "• Address Calculation of 1-D, 2-D, and 3-D Arrays"
                ]
            },
            {
                title: "Time & Space Complexity",
                topics: [
                    "• Best Case (Ω)",
                    "• Average Case (Θ)",
                    "• Worst Case (O)"
                ]
            },
            {
                title: "Stacks",
                topics: [
                    "• Definition, Operations, Applications",
                    "• Static (Array) and Dynamic (Linked List) Implementation"
                ]
            },
            {
                title: "Queues",
                topics: [
                    "• Definition, Operations, Applications",
                    "• Static (Array) and Dynamic (Linked List) Implementation"
                ]
            },
            {
                title: "Linked Lists",
                topics: [
                    "• Singly, Doubly, and Circular Linked Lists",
                    "• Definition and Applications"
                ]
            },
            {
                title: "Recursion & Backtracking",
                topics: [
                    "• Concept and Basic Problems with Implementation"
                ]
            },
            {
                title: "Sorting",
                topics: [
                    "• Let's Play with Code",
                    "• Incremental Approach:",
                    "  - Bubble Sort",
                    "  - Selection Sort",
                    "  - Insertion Sort",
                    "  - Radix Sort",
                    "• Divide & Conquer Approach:",
                    "  - Merge Sort",
                    "  - Quick Sort",
                    "  - Heap Sort"
                ]
            },
            {
                title: "Searching",
                topics: [
                    "• Linear Search",
                    "• Binary Search"
                ]
            },
            {
                title: "Dynamic Programming",
                topics: [
                    "• Optimization on Recursion",
                    "• Tabulation and Memorization",
                    "• Solutions to Common Problems"
                ]
            },
            {
                title: "Trees",
                topics: [
                    "• Binary Trees and Binary Search Trees",
                    "• Definition, Creation, Implementation, and Traversals",
                    "• AVL Trees"
                ]
            },
            {
                title: "Graphs",
                topics: [
                    "• Definition, Operations, Applications",
                    "• Graph Algorithms (Dijkstra's, Bellman-Ford)"
                ]
            },
            {
                title: "Hashing Techniques",
                topics: [
                    "• Concept and Collision Handling Techniques",
                    "• How to Select Hashing Functions"
        ]
    },
    {
                title: "Greedy Algorithms",
                topics: [
                    "• Need & Concepts",
                    "• Solutions to Common Problems"
                ]
            }
        ],
        skills: [
            "C Programming",
            "C++ Programming",
            "Object-Oriented Programming",
            "Data Structures",
            "Algorithms",
            "Problem-Solving",
            "Memory Management",
            "System Programming"
        ]
    },
    {
        id: "oops-cpp",
        slug: "oops-cpp",
        title: "OOPs in C++",
        category: "self-paced",
        description: "Object-Oriented Programming (OOP) is the heart of modern software development, and C++ is one of the most powerful languages to learn it with.This course is specially designed by OSOPCoding to give you a clear, practical, and error-free understanding of OOPs in C++. Whether you're preparing for interviews, building real projects, or strengthening your concepts — this course is your shortcut to writing clean, modular, and reusable code.",
        image: "/path/to/oops-cpp-image.jpg",
        price: 1590,
        originalPrice: 3000,
        externalUrl: "https://gontq.courses.store/692903?utm_source%3Dother%26utm_medium%3Dtutor-course-referral%26utm_campaign%3Dcourse-overview-webapp",
        level: "Beginner to Intermediate",
        tools: ["Turbo C++", "Visual Studio Code", "GCC Compiler", "Code::Blocks"],
        duration: "45 Days",
        lectures: "35+",
        mode: "Self Paced",
        language: "Hindi/English",
        certificate: "Industry Recognized Certificate",
        tests: "10+",
        assignments: "10+",
        banner: {
            title: "OOPs in C++",
            subtitle: "Master Object-Oriented Programming",
            background: "bg-gradient-to-r from-blue-600 to-indigo-600",
            Icon: Code
        },
        // overview: "Whether you are a beginner or looking to enhance your programming skills, this course will guide you through essential topics and hands-on projects.",
        prerequisites: "Basic knowledge of programming concepts is recommended. No prior C++ experience required.",
        highlights: [
            "Most Premium Course",
            "No Experience Needed",
            "Problem-Solving Techniques",
            "Assessment via Online Test",
            "Practical Approach",
            "Access to our Placement cell"
        ],
        whyOsop: [
            "India's Most Premium Coding Class",
            "26+ Years of Technology Training",
            "Zero Error Programming",
            "Strong Conceptual & Practical Knowledge"
        ],
        selfPacedFeatures: [
         "Learn at your own pace",
            "24/7 access to learning materials",
            "Flexible learning schedule",
            "Assignments & Online Test",
            "Downloadable resources"
        ],
        learningFormat: {
            duration: "Self-paced",
            mode: "Online",
            effort: "8-10 hours/week recommended",
            includes: [
                "HD Quality Videos",
                "Hands-on Projects",
                "Assignments & Quizzes",
                "Doubt Resolution",
                "Certificate of Completion"
            ]
        },
        curriculum: [
            {
                title: "Introduction to C++",
                topics: [
                    "• Overview of C++ and its uses"
                ]
            },
            {
                title: "Basic Input/Output",
                topics: [
                    "• Using cout, cin, and endl"
                ]
            },
            {
                title: "Namespaces in C++",
                topics: [
                    "• Understanding namespaces and their importance"
                ]
            },
            {
                title: "Reference Variables",
                topics: [
                    "• Introduction to reference variables"
                ]
            },
            {
                title: "Function Overloading",
                topics: [
                    "• Concept and examples of function overloading"
                ]
            },
            {
                title: "std::string Class in C++",
                topics: [
                    "• String operations including size, length, empty, substr, find, replace, and compare",
                    "• Concatenation and appending strings"
                ]
            },
            {
                title: "Object-Oriented Programming (OOP)",
                topics: [
                    "• Introduction to OOP and its features",
                    "• Differences between object-oriented and procedural programming",
                    "• Features of OOP: Class, Object, Encapsulation, Abstraction, Inheritance, Polymorphism"
                ]
            },
            {
                title: "Access Modifiers",
                topics: [
                    "• Understanding public, private, and protected access modifiers"
                ]
            },
            {
                title: "this Pointer in C++",
                topics: [
                    "• Usage and importance of this pointer"
                ]
            },
            {
                title: "Scope Resolution Operator",
                topics: [
                    "• Examples using scope resolution operator with global and local variables",
                    "• Examples with class members"
                ]
            },
            {
                title: "Object Passing and Returning",
                topics: [
                    "• Concept of object passing and returning",
                    "• Example program demonstrating object passing and returning"
                ]
            },
            {
                title: "Constructors and Destructors",
                topics: [
                    "• Introduction to constructors and their types",
                    "• Understanding destructors"
                ]
            },
            {
                title: "Inline Functions",
                topics: [
                    "• Definition and usage of inline functions"
                ]
            },
            {
                title: "Static Members and Functions",
                topics: [
                    "• Concept of static members and static functions",
                    "• Object counting example"
                ]
            },
            {
                title: "Dynamic Memory Management",
                topics: [
                    "• Difference between dynamic object and dynamic constructor"
                ]
            },
            {
                title: "Friend Function and Friend Class",
                topics: [
                    "• Introduction to friend functions and classes"
                ]
            },
            {
                title: "Operator Overloading",
                topics: [
                    "• Concept and implementation of operator overloading"
                ]
            },
            {
                title: "Default Arguments",
                topics: [
                    "• Using default arguments in functions"
                ]
            },
            {
                title: "Inheritance and its Types",
                topics: [
                    "• Types of inheritance and their applications"
                ]
            },
            {
                title: "Function Overriding and Virtual Functions",
                topics: [
                    "• Understanding function overriding and virtual functions"
                ]
            },
            {
                title: "Abstract Classes",
                topics: [
                    "• Introduction to abstract classes and their significance"
                ]
            },
            {
                title: "Generalization and Specialization",
                topics: [
                    "• Concepts of generalization and specialization in OOP"
        ]
    },
    {
                title: "IS-A and HAS-A Relationship",
                topics: [
                    "• Understanding the relationships in OOP"
                ]
            },
            {
                title: "Exception Handling",
                topics: [
                    "• Introduction to exception handling mechanisms"
                ]
            },
            {
                title: "Templates in C++",
                topics: [
                    "• Function templates and class templates"
                ]
            },
            {
                title: "C++ IO Stream",
                topics: [
                    "• Introduction to C++ I/O stream and functions",
                    "• I/O formatting functions and manipulators",
                    "• User-defined manipulators"
                ]
            },
            {
                title: "File Handling in C++",
                topics: [
                    "• Introduction to file handling and file I/O",
                    "• File stream classes and operations",
                    "• Examples of file operations",
                    "• Binary mode operations"
                ]
            },
            {
                title: "Overloading Insertion and Extraction Operators",
                topics: [
                    "• Understanding operator overloading for I/O operations"
                ]
            }
        ],
        skills: [
            "C++ Programming",
            "Object-Oriented Programming",
            "Classes and Objects",
            "Inheritance",
            "Polymorphism",
            "Encapsulation",
            "Abstraction",
            "Operator Overloading"
        ]
    },
    {
        id: "python-for-beginners",
        slug: "python-programming",
        title: "python for beginners",
        externalUrl: "https://gontq.courses.store/491364?utm_source=other&utm_medium=tutor-course-referral&utm_campaign=course-overview-webapp",
        fallbackUrl: "https://gontq.courses.store/",
        category: "self-paced",
        description: "Python is the perfect first language — simple, powerful, and used everywhere from web apps to AI. This Python for Beginners course by OSOPCoding is designed for absolute beginners, with a unique zero-error programming approach that helps you write clean, bug-free code from Day One. Whether you're a student, career switcher, or curious creator — this course is your launchpad to the world of programming.",
        image: "/path/to/python-programming-image.jpg",
        price: 3710,
        originalPrice: 7000,
        level: "Beginner to Intermediate",
        tools: ["Python IDLE", "VS Code", "Jupyter Notebook", "MySQL" ],
        duration: "2 Months",
        lectures: "35+",
        mode: "Self Paced",
        language: "Hindi/English",
        certificate: "Industry Recognized Certificate",
        tests: "10+",
        assignments: "10+",
        banner: {
            title: "python for beginners",
            subtitle: "Fundamental concepts of python",
            background: "bg-gradient-to-r from-yellow-500 to-orange-500",
            Icon: Code
        },
        // overview: "This course provides a complete Python learning journey from basic syntax to advanced web development, including database programming and modern web frameworks.",
        prerequisites: "No prior programming experience required. Basic computer literacy is sufficient to start this course.",
        highlights: [
             "Most Premium Course",
            "No Experience Needed",
            "Problem-Solving Techniques",
            "Assessment via Online Test",
            "Practical Approach",
            "Access to our Placement cell"
        ],
        whyOsop: [
            "India's most premium coding class",
            "26+ Years of Technology Training",
            "Zero Error Programming",
            "Strong Conceptual & Practical Knowledge"
        ],
        selfPacedFeatures: [
       "Learn at your own pace",
            "24/7 access to learning materials",
            "Flexible learning schedule",
            "Assignments & Online Test",
            "Downloadable resources"
        ],
        learningFormat: {
            duration: "Self-paced",
            mode: "Online",
            effort: "10-12 hours/week recommended",
            includes: [
                "HD Quality Videos",
                "Hands-on Projects",
                "Assignments & Quizzes",
                "Doubt Resolution",
                "Certificate of Completion"
            ]
        },
        curriculum: [
            {
                title: "Overview of Python",
                topics: [
                    "• History, Features & Uses of Python",
                    "• Installation, IDE Setup (IDLE, VS Code, PyCharm)",
                    "• Working with Python Shell & Files",
                    "• Basic Syntax, Comments, Indentation, Input/Output",
                    "• Variables, Data Types & Type Casting"
                ]
            },
            {
                title: "Operators, Decision Making & Looping",
                topics: [
                    "• Operators: Arithmetic, Relational, Logical, Assignment, Membership, Identity",
                    "• Conditional Statements: if, if-else, elif, Nested if",
                    "• Looping: while, for, nested, range()",
                    "• Loop Control: break, continue, pass",
                    "• Type Conversion & Operator Precedence"
                ]
            },
            {
                title: "Functions and Modules",
                topics: [
                    "• Defining Functions, Arguments, Return Values",
                    "• f-Strings & String Formatting Operations",
                    "• Lambda (Anonymous) Functions",
                    "• Scope: Global & Local Variables",
                    "• Built-in Modules (Math, Time, Random)",
                    "• Creating & Importing Custom Modules",
                    "• Python Packages and Init File (__init__.py)"
                ]
            },
            {
                title: "Data Structures in Python",
                topics: [
                    "• Strings: Accessing, Slicing, String Methods",
                    "• Lists: Indexing, Slicing, Functions & Methods",
                    "• Tuples: Creation, Access, Immutability",
                    "• Sets: Operations, Unique Element Filtering",
                    "• Dictionaries: Key-Value Pairs, Access, Methods",
                    "• Collections Module: deque, Counter, defaultdict, OrderedDict, namedtuple"
                ]
            },
            {
                title: "File Handling & Exception Handling",
                topics: [
                    "• File Operations: Open, Read, Write, Append, Close",
                    "• Reading from Keyboard",
                    "• File Modes: r, w, a, x, b, t",
                    "• Exception Types, Try-Except, Else, Finally",
                    "• Custom Exceptions, Assertion Handling"
                ]
            },
            {
                title: "Object-Oriented Programming (OOP)",
                topics: [
                    "• Classes & Objects",
                    "• __init__() Constructor, self Keyword",
                    "• Encapsulation, Inheritance, Polymorphism",
                    "• Overriding, Abstraction",
                    "• Decorators & Descriptors",
                    "• Class vs Instance Variables"
                ]
            }
           
        ],
        skills: [
            "Python Programming",
            "Object-Oriented Programming",
            "Database Programming",
            "Web Development",
            "Django Framework",
            "HTML & CSS",
            "MySQL Database",
            "Git Version Control"
        ]
    },
    {
        id: "c-cpp-foundation",
        slug: "c-cpp-foundation",
        title: "C/C++ Foundation Course",
        externalUrl: "https://gontq.courses.store/339206?utm_source=other&utm_medium=tutor-course-referral&utm_campaign=course-overview-webapp",
        fallbackUrl: "https://gontq.courses.store/",
        category: "self-paced",
        description: "The C/C++ Foundation Course by OSOPCoding is your all-in-one gateway to understanding the core of programming. Whether you're a complete beginner or someone looking to strengthen your basics, this course will help you write clean, efficient, and error-free code from Day One. C and C++ are the building blocks of modern software — and mastering them means building the mindset of a true developer.",
        image: "/path/to/c-cpp-foundation-image.jpg",
        price: 3710,
        originalPrice: 7000,
        level: "Beginner to Intermediate",
        tools: ["GCC Compiler", "Visual Studio", "Code::Blocks", "Dev-C++", "Turbo C++"],
        videoUrl: "https://youtu.be/HspM4qB8U0s?si=LejlXemQWRlcp5_g",
         duration: "3 Months",
        lectures: "55+",
        mode: "Self Paced",
        language: "Hindi/English",
        certificate: "Industry Recognized Certificate",
        tests: "10+",
        assignments: "10+",
        banner: {
            title: "C/C++ Foundation",
            subtitle: "Master Procedural & Object-Oriented Programming",
            background: "bg-gradient-to-r from-cyan-600 to-blue-600",
            Icon: Code
        },
        // overview: "This course provides a complete learning path from C programming fundamentals to advanced C++ object-oriented concepts, equipping students with essential programming skills for software development.",
        prerequisites: "No prior programming experience required. Basic computer literacy is sufficient to start this course.",
        highlights: [
            "Most Premium Course",
            "No Experience Needed",
            "Problem-Solving Techniques",
            "Assessment via Online Test",
            "Practical Approach",
            "Access to our Placement cell"
        ],
        whyOsop: [
            "India's most premium coding class",
            "26+ Years of Technology Training",
            "Zero Error Programming",
            "Strong Conceptual & Practical Knowledge"
        ],
        selfPacedFeatures: [
         "Learn at your own pace",
            "24/7 access to learning materials",
            "Flexible learning schedule",
            "Assignments & Online Test",
            "Downloadable resources"
        ],
        learningFormat: {
            duration: "Self-paced",
            mode: "Online",
            effort: "10-12 hours/week recommended",
            includes: [
                "HD Quality Videos",
                "Hands-on Projects",
                "Assignments & Quizzes",
                "Doubt Resolution",
                "Certificate of Completion"
            ]
        },
        curriculum: [
            {
                title: "Module 1: Foundation in C Programming",
                topics: [
                    "• Introduction to Computer & C",
                    "  - Basics of computer systems & OS",
                    "  - History and applications of C",
                    "  - Structure of a C program",
                    "• Fundamentals of C",
                    "  - Variables, Constants, Data Types",
                    "  - Operators (Arithmetic, Relational, Logical, Bitwise, Assignment)",
                    "  - Type Casting and ASCII",
                    "  - Algorithm & Flowchart Design",
                    "• Control Structures",
                    "  - Conditional Statements: if, if-else, Ladder if-else, switch",
                    "  - Looping: while, do-while, for, Nested loops",
                    "  - Jump Statements: break, continue, goto",
                    "• Functions & Storage",
                    "  - Function Declaration & Definition",
                    "  - Recursion",
                    "  - Storage Classes",
                    "  - Preprocessor Directives",
                    "• Arrays & Strings",
                    "  - 1D and 2D Arrays",
                    "  - Array-Pointer Relationship",
                    "  - String Manipulations and Functions",
                    "  - Matrix operations",
                    "• Pointers & Dynamic Memory",
                    "  - Pointer Basics & Types",
                    "  - Pointer Arithmetic",
                    "  - Dynamic Memory Allocation (malloc, calloc, etc.)",
                    "• User-Defined Data Types",
                    "  - Structures and Unions",
                    "  - typedef and enum",
                    "• File Handling in C",
                    "  - File Opening Modes and Functions",
                    "  - Reading/Writing Files",
                    "  - File Pointers and Cursor Movement"
        ]
    },
    {
                title: "Module 2: Object-Oriented Programming with C++",
                topics: [
                    "• C++ Fundamentals",
                    "  - Basics of C++: cin, cout, endl, namespace",
                    "  - Reference Variables & Function Overloading",
                    "  - std::string class operations",
                    "• Core OOP Concepts",
                    "  - Class & Object",
                    "  - Encapsulation, Abstraction",
                    "  - Inheritance (Single, Multiple, Multilevel, Hierarchical, Hybrid)",
                    "  - Polymorphism: Compile-Time & Run-Time",
                    "  - Object Passing and Returning",
                    "• Advanced C++ Concepts",
                    "  - this pointer",
                    "  - Scope Resolution Operator",
                    "  - Static Members & Functions",
                    "  - Constructors & Destructors (Types, Overloading)",
                    "  - Inline Functions",
                    "  - Default Arguments",
                    "• Operator Overloading",
                    "  - Arithmetic & Relational Operator Overloading",
                    "  - Overloading << and >> (Insertion & Extraction)",
                    "• Friend Functions & Classes",
                    "  - Use cases and syntax",
                    "• Memory & Exception Handling",
                    "  - Dynamic Object Creation",
                    "  - Exception Handling (try, catch, throw)",
                    "• Templates & Generic Programming",
                    "  - Function Templates",
                    "  - Class Templates",
                    "• File Handling in C++",
                    "  - File Streams and Modes",
                    "  - Text and Binary File Operations",
                    "  - I/O Formatting & Manipulators",
                    "  - User-defined Manipulators",
                    "• OOP Relationships",
                    "  - IS-A vs HAS-A",
                    "  - Generalization and Specialization",
                    "  - Abstract Classes & Virtual Functions"
                ]
            }
        ],
        skills: [
            "C Programming",
            "C++ Programming",
            "Object-Oriented Programming",
            "Procedural Programming",
            "Memory Management",
            "File Handling",
            "Data Structures",
            "Algorithm Design"
        ]
    },
    {
        id: "c-beginners",
        slug: "c-beginners",
        title: "C for Beginners",
        externalUrl: "https://gontq.courses.store/683150?utm_source=other&utm_medium=tutor-course-referral&utm_campaign=course-overview-webapp",
        fallbackUrl: "https://gontq.courses.store/",
        category: "self-paced",
        description: "C is the perfect starting point — simple, powerful, and the backbone of modern software development. The C for Beginners course by OSOPCoding is designed to help you understand programming from the ground up — with a focus on writing error-free, logical, and clean code from the very beginning. Whether you're a student, a tech enthusiast, or a future developer, this course is your first step into the coding world.",
        image: "/path/to/c-beginners-image.jpg",
        price: 2385,
        originalPrice: 4500,
        level: "Beginner",
        tools: ["Turbo C++", "VS Code", "GCC Compiler", "Code::Blocks"],
         duration: "2 Months",
        lectures: "55+",
        mode: "Self Paced",
        language: "Hindi/English",
        certificate: "Industry Recognized Certificate",
        tests: "10+",
        assignments: "10+",
        banner: {
            title: "C for Beginners",
            subtitle: "Master Core Programming Concepts",
            background: "bg-gradient-to-r from-gray-600 to-gray-800",
            Icon: Code
        },
        // overview: "This course introduces the basic concepts of C programming, starting from the very fundamentals to more intermediate topics. It is designed for people with no prior programming experience.",
        prerequisites: "No prior programming experience required. Basic computer literacy is sufficient to start this course.",
        highlights: [
           "Most Premium Course",
            "No Experience Needed",
            "Problem-Solving Techniques",
            "Assessment via Online Test",
            "Practical Approach",
            "Access to our Placement cell"
        ],
        whyOsop: [
            "India's most premium coding class",
            "26+ Years of Technology Training",
            "Zero Error Programming",
            "Strong Conceptual & Practical Knowledge"
        ],
        selfPacedFeatures: [
           "Learn at your own pace",
            "24/7 access to learning materials",
            "Flexible learning schedule",
            "Assignments & Online Test",
            "Downloadable resources"
        ],
        learningFormat: {
            duration: "Self-paced",
            mode: "Online",
            effort: "8-10 hours/week recommended",
            includes: [
                "HD Quality Videos",
                "Hands-on Projects",
                "Assignments & Quizzes",
                "Doubt Resolution",
                "Certificate of Completion"
            ]
        },
        curriculum: [
            {
                title: "Introduction to Computer & C Programming",
                topics: [
                    "• Introduction to Computer",
                    "• Definition and functions of an Operating System",
                    "• Brief History and Uses of C Programming"
                ]
            },
            {
                title: "C Basics",
                topics: [
                    "• Variable & Constant",
                    "• Introduction to Data Types",
                    "• Introduction to ASCII",
                    "• Introduction to Operators and Types",
                    "• Type Casting in C Programming",
                    "• Algorithm and Flowchart"
                ]
            },
            {
                title: "C Programming Structure",
                topics: [
                    "• Basic C Programs",
                    "• Types of Errors in C Programming"
                ]
            },
            {
                title: "Conditional Statements",
                topics: [
                    "• Conditional Statement (if..else)",
                    "• Relational (Comparison) Operators",
                    "• Basic C if..else Programs",
                    "• Logical Operators in C Programming",
                    "• Conditional Operator in C Programming",
                    "• Ladder if...else"
                ]
            },
            {
                title: "Operators in C",
                topics: [
                    "• Increment / Decrement Operators",
                    "• Introduction to Number Systems",
                    "• Definition and Purpose of Bitwise Operators in C",
                    "• C Assignment Operators",
                    "• C Operator Precedence"
                ]
            },
            {
                title: "Looping Statements",
                topics: [
                    "• Introduction to Loops & Types",
                    "• while Loop",
                    "• do while Loop",
                    "• for Loop",
                    "• Nested Loops"
                ]
            },
            {
                title: "Jump Statements in C Programming",
                topics: [
                    "• Break Statement",
                    "• Continue Statement",
                    "• Goto Statement"
                ]
            },
            {
                title: "Switch Statement",
                topics: [
                    "• Introduction to switch Statement"
                ]
            },
            {
                title: "Functions in C Programming",
                topics: [
                    "• Introduction to Functions in C Programming",
                    "• Storage Classes in C Programming",
                    "• Preprocessor Directives"
                ]
            },
            {
                title: "Pointers in C",
                topics: [
                    "• Introduction to Pointers",
                    "• Types of Pointers",
                    "• Pointer to Array",
                    "• Dynamic Memory Management"
                ]
            },
            {
                title: "Recursion",
                topics: [
                    "• Introduction to Recursion"
                ]
            },
            {
                title: "Arrays in C",
                topics: [
                    "• Introduction to Array & Its Types",
                    "• Pointer to Array",
                    "• Introduction to String",
                    "• Useful String Functions",
                    "• Example Code for String Operations"
                ]
            },
            {
                title: "2D Arrays",
                topics: [
                    "• Introduction to 2D Arrays",
                    "• Example Code for Creating and Adding Elements in a 2D Array",
                    "• Example Code for Transposing a Matrix Using 2D Array"
                ]
            },
            {
                title: "User-Defined Data Types",
                topics: [
                    "• Introduction to User-Defined Data Types",
                    "• Structure",
                    "• Union",
                    "• Typedef",
                    "• Enum"
                ]
            },
            {
                title: "File Handling",
                topics: [
                    "• File Handling Operations",
                    "• File Handling Functions",
                    "• Modes of File Opening",
                    "• Example Codes",
                    "• File Pointer Movement Functions"
                ]
            }
        ],
        skills: [
            "C Programming",
            "Procedural Programming",
            "Memory Management",
            "File Handling",
            "Data Structures",
            "Algorithm Design",
            "System Programming"
        ]
    }
]; 